import { render, staticRenderFns } from "./AudioNoticeboardCreateOrUpdate.vue?vue&type=template&id=21e916aa&scoped=true&"
import script from "./AudioNoticeboardCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./AudioNoticeboardCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AudioNoticeboardCreateOrUpdate.vue?vue&type=style&index=0&id=21e916aa&prod&lang=scss&scoped=true&"
import style1 from "./AudioNoticeboardCreateOrUpdate.vue?vue&type=style&index=1&id=21e916aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e916aa",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardActions,QBtn});
